var React = require('react');

function IconFeedback (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M-4-4h36v36H-4z","key":0}),React.createElement("path",{"className":"draw","fill":"#61C250","d":"M27.125.5h-24a2.996 2.996 0 0 0-2.985 3l-.015 27 6-6h21c1.65 0 3-1.35 3-3v-18c0-1.65-1.35-3-3-3zM10.625 14h-3v-3h3v3zm6 0h-3v-3h3v3zm6 0h-3v-3h3v3z","key":1})]));
}

IconFeedback.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31"};

module.exports = IconFeedback;

IconFeedback.default = IconFeedback;
